import { render, staticRenderFns } from "./Expand.vue?vue&type=template&id=48ac4b54&scoped=true&lang=pug&"
import script from "./Expand.vue?vue&type=script&lang=ts&"
export * from "./Expand.vue?vue&type=script&lang=ts&"
import style0 from "./Expand.vue?vue&type=style&index=0&id=48ac4b54&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ac4b54",
  null
  
)

component.options.__file = "Expand.vue"
export default component.exports